<ng-template #projectedContent>
	<ng-content></ng-content>
</ng-template>

<div [id]="widgetId">
	<ng-container *ngIf="!doNotUseCard; else noCard">
		<div class="card mb-3">
			<div class="card-header">
				<a href="javascript:">
				<i (click)="toggleCollapse()" class="fa mr-1"
					[ngClass]="{'fa-minus': !isCollapsed, 'fa-plus': isCollapsed}"></i>
				</a>
				<strong>
					{{ title }}
					<app-help-tooltip *ngIf="tooltipKey" [isSmall]="true" [field]="tooltipKey" class="noprint"></app-help-tooltip>
				</strong>
			</div>
			<div *ngIf="!isCollapsed" class="card-body">
				<ng-container *ngTemplateOutlet="projectedContent"></ng-container>
			</div>
		</div>
	</ng-container>

	<ng-template #noCard>
		<div class="row">
			<h1 class="h3 m-4">
				{{ title }}
				<app-help-tooltip *ngIf="tooltipKey" [isSmall]="false" [field]="tooltipKey" class="noprint"></app-help-tooltip>
			</h1>
		</div>
		<div class="p-3">
			<ng-container *ngTemplateOutlet="projectedContent"></ng-container>
		</div>
	</ng-template>
</div>
